var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrayBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 414,
    viewBox: "0 0 297 414",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297 413.999C207 377.5 10.9998 210.002 0 1C252 0.994216 251.195 0.999488 263 0.999488C268.554 0.999386 269.723 0.849059 272.5 1.49882C275.5 1.99882 278.392 3.19498 281 4.49882C283 5.49882 286 7.49882 288.5 9.99882C290.279 12.0315 292.5 14.4988 294 17.9988C294.5 18.4988 296 22.4988 296.589 25.7129C296.836 27.5447 297 28.4988 297 32.4995C297 32.4995 297 217.604 297 413.999Z",
    fill: "black",
    fillOpacity: 0.02
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayBg);
export default __webpack_public_path__ + "static/media/GrayBg.9f7afcc3f5889e6656b770b2285664e5.svg";
export { ForwardRef as ReactComponent };